import React from 'react';
import { useT } from '../i18n.jsx';

export function FreeApiAccessNotice({ authed, user, hasKey, rejected = false, navigate }) {
  const { t } = useT();
  const registered = authed && user?.accountType === 'ENTITY';
  if (registered && hasKey && !rejected) return null;
  const mode = !authed ? 'signin' : !registered ? 'complete' : rejected ? 'switchKey' : 'setKey';
  const onContinue = () => {
    if (mode === 'signin') navigate('login', { reason: 'free-api' });
    else if (mode === 'complete') navigate('bind');
    else navigate('console', { tab: 'env', focus: 'XAPI_KEY' });
  };
  return (
    <div role={rejected ? 'alert' : 'note'} className="card" style={{ padding: 16, borderColor: 'var(--warn)' }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>{t(registered ? 'apidetail.free.readyTitle' : 'apidetail.free.title')}</div>
      <p style={{ margin: '6px 0 12px', fontSize: 12, lineHeight: 1.7, color: 'var(--fg-3)' }}>{t(`apidetail.free.${mode}`)}</p>
      <div className="row gap-2" style={{ flexWrap: 'wrap' }}>
        <button type="button" className="btn btn-sm btn-primary" onClick={onContinue}>{t(`apidetail.free.${mode}Action`)}</button>
        {registered && <button type="button" className="btn btn-sm" onClick={() => navigate('console', { tab: 'keys' })}>{t('apidetail.free.keysAction')}</button>}
        {authed && !registered && <button type="button" className="btn btn-sm" onClick={() => navigate('login', { reason: 'free-api' })}>{t('apidetail.free.existingAction')}</button>}
      </div>
    </div>
  );
}

export const isFreeApiAccountError = (response) => {
  if (![401, 403].includes(Number(response?.status))) return false;
  const body = response?.body;
  return body?.code === 'FREE_API_ACCOUNT_REQUIRED' || body?.error?.code === 'FREE_API_ACCOUNT_REQUIRED' || body?.error === 'account_required';
};
